module.exports = __webpack_public_path__ + "assets/img/5cb35240a91c829cf69af738c27322bc.svg";